import "./DownloadApp.scss";
import AboutImg from "../../../assets/images/HoufTow.svg";
import Logo from "../../../assets/images/MainLogo.svg";
import AppStore from "../../../assets/images/app-store-icon.png";
import PlayStore from "../../../assets/images/google-play-download-icon.png";
import Circle from "../../../assets/images/circle.svg";
// MUI Icons
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BuildIcon from "@mui/icons-material/Build";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SecurityIcon from "@mui/icons-material/Security";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../context/LanguageContext";

const DownloadApp = () => {
  const { language } = useLanguage();

  // Bilingual text content
  const texts = {
    ar: {
      downloadApp: "تنزيل التطبيق مجانــاً",
      exclusiveOffers: "احصل علي العديد من العروض الحصرية",
      advantages: {
        discounts: {
          title: "باقات متنوعة",
          description: "باقات تلبي جميع احتياجاتك",
        },
        maintenance: {
          title: "صيانة سريعة",
          description: "خدمة صيانة منزلية احترافية",
        },
        support: {
          title: "دعم فني",
          description: "نحن نهتم بتجاربك",
        },
        securePayment: {
          title: "دفع امن",
          description: "طريقة دفع آمنة 100%",
        },
      },
    },
    en: {
      downloadApp: "Download the App for Free",
      exclusiveOffers: "Get many exclusive offers",
      advantages: {
        discounts: {
          title: "Special Offers",
          description: "Exclusive discounts on maintenance services",
        },
        maintenance: {
          title: "Quick Maintenance",
          description: "Professional home maintenance service",
        },
        support: {
          title: "Technical Support",
          description: "We care about your experience",
        },
        securePayment: {
          title: "Secure Payment",
          description: "100% secure payment method",
        },
      },
    },
  };

  // Get current language texts
  const currentTexts = texts[language] || texts.ar; // fallback to Arabic if lang is not set

  return (
    <div className="download">
      <div className="wrapper">
        <div className="right">
          <img src={AboutImg} alt="" />
          <div className="background"></div>
        </div>
        <div className="left">
          <img src={Logo} alt="" className="left-logo" />
          <h1>{currentTexts.downloadApp}</h1>
          <p>{currentTexts.exclusiveOffers}</p>
          <div className="links">
            <Link
              to="https://play.google.com/store/apps/details?id=com.arkan.houfelmanazel"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={PlayStore} alt="" />
            </Link>
            <Link
              to="https://apps.apple.com/us/app/houf-elmanazel/id6749190396"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={AppStore} alt="" />
            </Link>
          </div>
          {/* <div className="circle">
            <img src={Circle} alt="" />
          </div> */}
        </div>
      </div>
      <div className="advantages">
        <div className="item">
          <LocalOfferIcon sx={{ fontSize: 40, color: "#4CAF50" }} />
          <div className="text-container">
            <span>{currentTexts.advantages.discounts.title}</span>
            <p>{currentTexts.advantages.discounts.description}</p>
          </div>
        </div>
        <div className="item">
          <BuildIcon sx={{ fontSize: 40, color: "#FF9800" }} />
          <div className="text-container">
            <span>{currentTexts.advantages.maintenance.title}</span>
            <p>{currentTexts.advantages.maintenance.description}</p>
          </div>
        </div>
        <div className="item">
          <SupportAgentIcon sx={{ fontSize: 40, color: "#2196F3" }} />
          <div className="text-container">
            <span>{currentTexts.advantages.support.title}</span>
            <p>{currentTexts.advantages.support.description}</p>
          </div>
        </div>
        <div className="item">
          <SecurityIcon sx={{ fontSize: 40, color: "#9C27B0" }} />
          <div className="text-container">
            <span>{currentTexts.advantages.securePayment.title}</span>
            <p>{currentTexts.advantages.securePayment.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
